import React from "react";
import styles from "./Main.module.scss";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import { useTranslation } from "react-i18next";
import { FRONT_URL } from "../../../../http";

import pdf1 from '../../../../img/Pressestimmen.webp'
import pdf2 from '../../../../img/Projektubersicht.webp'
import pdf3 from '../../../../img/Presseinfo.webp'
import cloud from "../../../../img/cloud.svg";
import cn from "classnames";

const Main = ({ role }) => {
  const { t } = useTranslation();
  return (
    <section className={styles.documents}>
      <SectionTitle text={t("Sales Documents")} />
      <div
        className={cn(
          styles.documents__empty,
          role === "MAIN_SALE" ? styles.documents__empty_wrap : ""
        )}
      >
        <a
          href={`${FRONT_URL}/files/Pressestimmen.pdf`}
          className={styles.documents__block}
          download
        >
          <div className={styles.documents__block_wrapper}>
            <div className={styles.documents__short}>
              <img src={pdf1} alt="pdf" />
            </div>
            <div className={styles.documents__download}>
              <img src={cloud} alt="cloud" />
            </div>
          </div>
          <div className={styles.documents__name}>Pressestimmen.pdf</div>
          <div className={styles.documents__date}>
            {t("Status from:")} 11.04.2024{" "}
          </div>
        </a>
        <a
          href={`${FRONT_URL}/files/Projektubersicht.pdf`}
          className={styles.documents__block}
          download
        >
          <div className={styles.documents__block_wrapper}>
            <div className={styles.documents__short}>
              <img src={pdf2} alt="pdf" />
            </div>
            <div className={styles.documents__download}>
              <img src={cloud} alt="cloud" />
            </div>
          </div>
          <div className={styles.documents__name}>Projektubersicht.pdf</div>
          <div className={styles.documents__date}>
            {t("Status from:")} 11.04.2024{" "}
          </div>
        </a>
        <a
          href={`${FRONT_URL}/files/Presseinfo.pdf`}
          className={styles.documents__block}
          download
        >
          <div className={styles.documents__block_wrapper}>
            <div className={styles.documents__short}>
              <img src={pdf3} alt="pdf" />
            </div>
            <div className={styles.documents__download}>
              <img src={cloud} alt="cloud" />
            </div>
          </div>
          <div className={styles.documents__name}>Presseinfo.pdf</div>
          <div className={styles.documents__date}>
            {t("Status from:")} 11.04.2024{" "}
          </div>
        </a>
      </div>
    </section>
  );
};

export default Main;
